import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { MerchantsApiService } from '@app/areas/merchants/services/merchants.api.service';

interface MerchantDetailTab {
  path: string;
  label: string;
}

@Component({
  selector: 'app-merchant-detail',
  templateUrl: './merchant-detail.component.html',
  styleUrls: ['./merchant-detail.component.scss'],
  standalone: true,
  imports: [NgForOf, NgIf, RouterLink, RouterLinkActive, RouterOutlet],
})
export class MerchantDetailComponent implements OnInit, OnDestroy {
  private readonly merchantsApiService = inject(MerchantsApiService);
  private readonly route = inject(ActivatedRoute);
  private subs = new Subscription();

  protected readonly tabs: MerchantDetailTab[] = [
    { path: 'overview', label: 'Overview' },
    { path: 'locations', label: 'Locations' },
    { path: 'orders', label: 'Transactions' },
    { path: 'employees', label: 'Employees' },
    { path: 'devices', label: 'Devices' },
    { path: 'access', label: 'Access' },
  ];

  protected merchantName: string | null = null;

  ngOnInit(): void {
    this.subs.add(
      this.route.paramMap
        .pipe(
          map((params) => Number(params.get('merchantId'))),
          switchMap((merchantId) => this.merchantsApiService.getById(merchantId))
        )
        .subscribe((merchant) => {
          this.merchantName = merchant?.Name ?? null;
        })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
